<template>
  <div v-if="!$auth.user" class="auth-container">
    <v-dialog v-model="loginModal" width="350">
      <template v-slot:activator="{ on, attrs }">
        <div class="tw-flex tw-items-center tw-justify-between md:tw-space-x-6 tw-pr-4" v-bind="attrs" v-on="on">
          <v-img class="tw-w-[20px] md:tw-w-[40px]" :src="require('@/assets/2ezlogo.svg')"></v-img>
          <div>Login</div>
          <span></span>
        </div>
      </template>
      <Login @closeModal="closeAll" v-if="loginModal" @toRegister="showRegister"></Login>
    </v-dialog>

    <v-dialog v-model="registerModal" width="340">
      <Register @closeModal="closeAll" v-if="registerModal" @toLogin="showLogin"></Register>
    </v-dialog>
  </div>
  <div v-else class="auth-container">
    <div>
      <v-menu :offset-y="true" :nudge-bottom="5">
        <template v-slot:activator="{ on, attrs }">
          <div class="tw-flex tw-items-center tw-justify-between tw-space-x-2 md:tw-space-x-6" v-bind="attrs" v-on="on">
            <v-img class="tw-w-[20px] md:tw-w-[40px]" :src="require('@/assets/2ezlogo.svg')"></v-img>
            <div>
              <div v-if="!playGame" class="tw-rounded-sm tw-text-xs sm:tw-text-sm tw-font-bold">
                &#8369; {{ numberFormat($auth.user.credits || 0, "0,0.00") }}
              </div>
              <div v-else class="tw-rounded-sm tw-text-xs sm:tw-text-sm tw-font-bold">Playing: {{ playGame }}</div>
            </div>
            <v-icon color="white">mdi-chevron-down</v-icon>
          </div>
        </template>
        <div class="tw-bg-[#133063] tw-py-2 tw-mt-1 tw-rounded-tl-xl tw-rounded-b-xl tw-shadow-lg">
          <div>
            <div class="tw-text-lg tw-text-right tw-text-white tw-px-4 tw-py-2 tw-font-bold">{{ $auth.user.name }}</div>
            <div
              v-if="!playGame"
              class="py-1 text-right px-2 tw-rounded-sm tw-text-white tw-font-normal tw-text-sm tw-bg-[#132647]"
            >
              EZ Credits: &#8369; {{ numberFormat($auth.user.credits || 0, "0,0.00") }}
            </div>
            <div
              v-else
              class="py-1 text-right px-2 tw-rounded-sm tw-text-white tw-font-normal tw-text-sm tw-bg-[#132647]"
            >
              Playing: {{ playGame }}
            </div>
          </div>
          <div @click="toPath('/admin/games')" class="tw-profile-menu" v-if="$auth.user && $auth.is_super_admin">
            <v-icon small class="tw-mt-[2px]">mdi-shield-crown </v-icon><span class="tw-ml-4">Admin</span>
          </div>
          <div @click="toPath('profile')" class="tw-profile-menu">
            <v-icon small class="tw-mt-[2px]">mdi-account </v-icon><span class="tw-ml-4">My Profile</span>
          </div>
          <div @click="logout" class="tw-profile-menu">
            <v-icon small class="tw-mt-[2px]">mdi-logout </v-icon><span class="tw-ml-4"> Logout</span>
          </div>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>
import Login from "./Login.vue";
import Register from "./Register.vue";
import numeral from "numeral";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    Register,
    Login,
  },
  data: () => ({
    authModal: false,
    loginModal: false,
    registerModal: false,
  }),
  mounted() {},
  computed: {
    ...mapState("game", ["playGame"]),
    ...mapState("user", ["isLoginShow"]),
  },
  watch: {
    isLoginShow() {
      if (this.loginModal != this.isLoginShow) this.loginModal = this.isLoginShow;
    },
    loginModal() {
      if (this.loginModal != this.isLoginShow) this.setShowLogin(this.loginModal);
    },
  },
  methods: {
    ...mapMutations("user", ["setShowLogin"]),
    showLogin() {
      this.loginModal = true;
      this.setShowLogin(this.loginModal);
      this.registerModal = false;
    },
    showRegister() {
      this.loginModal = false;
      this.setShowLogin(this.loginModal);
      this.registerModal = true;
    },
    closeAll() {
      this.loginModal = false;
      this.setShowLogin(this.loginModal);
      this.registerModal = false;
    },
    numberFormat(amount, format) {
      return numeral(amount).format(format);
    },
    toPath(path) {
      if (path == "profile") {
        return window.open(process.env.VUE_APP_2EZ_URL + path, "_blank").focus();
      }
      this.$router.push(path);
    },
    async logout() {
      await this.$auth.logout();
      location.href = process.env.VUE_APP_SERVER_ENV == "prod" ? "/casino-games" : "/";
    },
  },
};
</script>

<style scoped>
.auth-container {
  @apply tw-flex tw-items-center tw-space-x-3 tw-font-bold tw-text-white tw-bg-[#2b57fb] tw-py-0.5 tw-px-0.5 tw-rounded-full;
}
</style>
